// Layout for the support-need surfaces (bead hf-e4-events-needs-6r5.2).
//
// CSS-only, like the surfaces beside it. The window fieldset is deliberately given a
// visible boundary and a tinted ground: it is the part of this form that is most
// often misread, and separating it from the fields around it is the layout half of
// the job the wording does.
export const needStylesheet = `
.need-form { display: grid; gap: var(--space-16, 1rem); max-width: 42rem; }
.need-form h2 { margin: 0; }
.need-form__hint, .need-form__window-hint { color: var(--color-ink-muted, #5b6862); margin: 0; }

.need-form__window { display: grid; gap: var(--space-12, 0.75rem);
  border: 1px solid var(--color-border, #d7ded9); border-radius: var(--radius-8, 0.5rem);
  padding: var(--space-16, 1rem); background: var(--color-surface-sunken, #f4f7f5); }
.need-form__window legend { font-weight: 600; padding: 0 var(--space-4, 0.25rem); }
.need-form__event-context { margin: 0; color: var(--color-ink-muted, #5b6862); }

.need-form__modes { display: grid; gap: var(--space-8, 0.5rem); border: 0; padding: 0; margin: 0; }
.need-form__modes legend { font-weight: 600; padding: 0; }
.need-form__checkbox { display: flex; align-items: center; gap: var(--space-8, 0.5rem);
  min-height: var(--target-size-44, 2.75rem); }

.need-detail__state { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); margin: 0 0 var(--space-12, 0.75rem); }
.need-detail__facts { display: grid; gap: var(--space-4, 0.25rem); margin: 0;
  grid-template-columns: minmax(10rem, auto) 1fr; }
.need-detail__facts dt { font-weight: 600; color: var(--color-ink-muted, #5b6862); }
.need-detail__facts dd { margin: 0; }
.need-detail__supplementary { margin-top: var(--space-16, 1rem); }
.need-detail__actions { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem);
  margin-top: var(--space-16, 1rem); }

.need-list__items { list-style: none; margin: 0; padding: 0; display: grid;
  gap: var(--space-12, 0.75rem); }
.need-list__item { padding-top: var(--space-12, 0.75rem);
  border-top: 1px solid var(--color-border, #d7ded9); }
.need-list__window { margin: 0; color: var(--color-ink-muted, #5b6862); }
.need-list__status { display: flex; flex-wrap: wrap; align-items: center;
  gap: var(--space-8, 0.5rem); margin: 0; }

@media (min-width: 1280px) {
  .need-detail__facts, .need-list__items { max-width: 720px; }
}
`;
